/**
 * @file React hook — useA1Location.ts: form/state logic for contributor dashboard.
 */

export const reverseGeocode = async (lat: number, lng: number) => {
  const res = await fetch(
    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
  );
  return res.json();
};